/**************************************************
 * Nombre:       Home_Portada
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, IconButton} from "@mui/material";
import fondo from '../../../Recursos/Temporales/fondo_home_portada.png'
import {REDES} from "../../../Constantes";
import Tarjeta_Anuncios from "../../Tarjetas/Tarjeta_Anuncios";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";

const Home_Portada = () => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                backgroundImage: 'linear-gradient(180deg, rgba(48, 51, 118, 0.76) 0%, rgba(48, 51, 118, 0.76) 100%),  url(' + fondo + ')',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                backgroundPosition: 'center center',
                pt: 15,
                mt: -16,
                pb: 15
            }}
        >

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'center'}
                        direction={'row-reverse'}
                        size={{xs: 12, sm: 12, md: 12}}
                    >

                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 11, md: 11}}>

                            {anuncios.map((item, i) => {
                                return (
                                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                        <Tarjeta_Anuncios/>
                                    </Grid>
                                )
                            })}

                        </Grid>

                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 1, md: 1}}
                            sx={{mt: -4, mb: sCell ? 5 : 0}}
                            spacing={2}
                        >

                            {REDES.map((item, i) => {
                                return (
                                    <Grid container size={{xs: 2, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                        <IconButton sx={{p: 0}}>
                                            <img src={item.icono} width={44} height={'auto'} alt={item.nombre}/>
                                        </IconButton>
                                    </Grid>
                                )
                            })}


                        </Grid>


                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Home_Portada

const anuncios = [1]